import { render, staticRenderFns } from "./SummaryStatisticsEmployer.vue?vue&type=template&id=efae2890&"
import script from "./SummaryStatisticsEmployer.vue?vue&type=script&lang=js&"
export * from "./SummaryStatisticsEmployer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports